<template>
  <v-card>
    <ValidateAll ref="form">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" md="6">
              <div class="headline">{{title()}}</div>
              <br />
              <!-- form goes here -->
              <v-skeleton-loader
                :loading="loading"
                class="actions__left"
                type="list-item-two-line,list-item-two-line, actions"
              >
                <Validate name="Nama" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Name"
                    label="Nama"
                    :error-messages="errors"
                    placeholder="Nama"
                    v-model="form.Name"
                    hide-details="auto"
                    dense
                    outlined
                    required
                  ></v-text-field>
                </Validate>
                <Validate name="Deskripsi" rules="required" #default="{ errors }">
                  <v-textarea
                    class="mb-3"
                    name="Description"
                    label="Deskripsi"
                    :error-messages="errors"
                    placeholder="Deskripsi"
                    v-model="form.Description"
                    hide-details="auto"
                    outlined
                    dense
                    required
                  ></v-textarea>
                </Validate>
                <span v-if="!$vuetify.breakpoint.xsOnly">
                  <v-btn class="mr-2" @click="reset">Ulang</v-btn>
                  <v-btn color="primary" @click="save()" :loading="saving">
                    <v-icon>mdi-content-save</v-icon>Simpan
                  </v-btn>
                </span>
              </v-skeleton-loader>
            </v-col>
            <v-divider vertical class="hidden-xs-only" />
            <v-col cols="12" md="6" class="mr-n1 mt-n9 mt-sm-0 mt-md-0 mt-lg-0 mt-xl-0">
              <div class="headline v-hidden hidden-sm-and-down">{{title()}}</div>
              <br />
              <v-skeleton-loader
                :loading="loading"
                class="actions__left"
                type="list-item-three-line"
              >
                <Validate name="Warna" rules="required" #default="{ errors }">
                  <v-color-picker
                    v-model="form.Color"
                    :error-messages="errors"
                    placeholder="Warna"
                    width="100%"
                    class="mb-3"
                    name="Color"
                    label="Warna"
                    mode="hexa"
                    hide-canvas
                    hide-mode-switch
                    show-swatches
                    required
                  ></v-color-picker>
                </Validate>
                <span v-if="$vuetify.breakpoint.xsOnly">
                  <v-btn class="mr-2" @click="reset">Ulang</v-btn>
                  <v-btn color="primary" @click="save()" :loading="saving">
                    <v-icon>mdi-content-save</v-icon>Simpan
                  </v-btn>
                </span>
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </ValidateAll>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    saving: false,
    loading: false,
    form: {
      Name: "",
      Description: "",
      Color: ""
    }
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", ["isKategoriLoading"])
  },
  methods: {
    async save() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      this.saving = true;
      this.$axios
        .post("/discussion/category", this.form)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });
          this.$router.push("/kategori-konseling");
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    reset() {
      // Object.assign(this.$data, this.$options.data());
      this.$refs.form.reset();
    },
    title() {
      return this.$route.params.id ? "Ubah Kategori" : "Kategori Baru";
    },

    ...mapActions("list", ["refreshKategori"])
  },
  async mounted() {
    this.refreshKategori();
    let id = this.$route.params.id;
    if (id) {
      this.loading = true;
      this.$axios
        .get(`/discussion/category/${id}`)
        .then(res => {
          this.loading = false;
          this.form = { ...this.form, ...res.data.Data };
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        });
    }
  }
};
</script>

<style>
</style>